<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa-solid fa-table-list" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              {{cvCardTitle}}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="gpath_career_univAdd()" >{{cvbtnAddNew}}</b-button>
          </div>
        </div>
        <div class="iq-card row p-3">
          <b-col lg="10" xl="10">
            <b-row>
              <b-col class="col-12 mb-3">
                <b-form-input
                  id="search"
                  v-model="filter"
                  type="search"
                  :placeholder="cvSearchText"></b-form-input>
              </b-col>
              <!-- GPath Producat Id -->
              <b-col class="mb-2 col-12 col-sm-6">
                <select v-model="whereFilter.pdt_id" class="form-control" title="session states" @change="setPdtId">
                  <option value="">Select Product Id</option>
                  <option v-for="item in gpcPdtIdList" :key="item.id" :value="item.id" >
                    {{ item.id }}
                  </option>
                </select>
              </b-col><!-- GPath Producat Id -->
              <b-col class="mb-2 col-12 col-sm-6">
                <select v-model="whereFilter.country" class="form-control" @change="setCountry">
                  <option value="">Select Country</option>
                  <option v-for="(country, index) of countryList" :key="(index+1)" :value="country.country">
                    {{country.country}}
                  </option>
                </select>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="col-12 col-sm-12 col-md-12 col-lg-2 mb-3">
            <div v-if="userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'">
              <CsvDownload :propModuleFile="cvModuleFile" class="Download_button" />
              <CsvUpload :propModulePrefix="cvModulePrefix" class="btn Download_button"  />
            </div>
            <VueJsonToCsv :json-data="gpath_career_univObjList" csv-title="gpath_career_univ_list" v-if="gpath_career_univObjList && gpath_career_univObjList.length">
              <i class="fa-solid fa-file-csv Download_button"></i>
            </VueJsonToCsv>
          </b-col>
        </div>
        <div class="iq-card row p-3">
          <b-col class="container_minheight" md="12" v-if="gpath_career_univObjList && gpath_career_univObjList.length > 0">
            <b-table
              hover
              responsive
              :items="gpath_career_univObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentPage"
              :per-page="perPage"
            >
              <template v-slot:cell(name)="data">
                {{ data.item.name }}
                <br>
                <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-sm" size="sm" @click="gpath_career_univEdit('MODAL', data.item)" v-if="!data.item.editable"><i class="ri-ball-pen-fill m-0 primary-color"></i></b-button>
                <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-sm" @click="showGPathCareerUnivDeleteDialog(data.item)" size="sm"><i class="ri-delete-bin-line m-0 primary-color"></i></b-button>
              </template>
            </b-table>
          </b-col>
          <b-col class="container_minheight" md="12" v-else>
            No data found
          </b-col>
          <b-col sm="7" md="8" class="my-1"></b-col>
          <b-col sm="5" md="4" class="my-1">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModelGPathCareerUnivAdd"
      scrollable
      :title="cvAddModalHeader"
    >
      <GPathCareerUnivAdd :propOpenedInModal="true" @emitCloseGPathCareerUnivAddModal="closeGPathCareerUnivAddModal()" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="gpath_career_univAdd('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeGPathCareerUnivAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelGPathCareerUnivEdit"
      scrollable
      :title="cvEditModalHeader"
      size="xl"
    >
      <GPathCareerUnivEdit :propOpenedInModal="true" :propGPathCareerUnivObj="gpath_career_univEditObj" @emitCloseGPathCareerUnivEditModal="closeGPathCareerUnivEditModal()" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="gpath_career_univEdit('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeGPathCareerUnivEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelGPathCareerUnivDelete" title="Delete" ok-title="Delete" cancel-title="Cancel" size="xl">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelGPathCareerUnivDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="gpath_career_univDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import { GPathCareerUnivs } from "../../../FackApi/api/GPathCareerUniv.js"
import GPathCareerUnivAdd from "./GPathCareerUnivAdd"
import GPathCareerUnivEdit from "./GPathCareerUnivEdit"
import moment from "moment"
import ApiResponse from "../../../Utils/apiResponse"
import { socialvue } from "../../../config/pluginInit"
import userPermission from "../../../Utils/user_permission"
import CsvUpload from "../../../components/Csv/CsvUpload.vue"
import CsvDownload from "../../../components/Csv/CsvDownload.vue"
import { GPathConfig } from "../../../FackApi/api/GpathConfig"

export default {
  name: "GPathCareerUnivList",
  components: {
    GPathCareerUnivAdd,
    GPathCareerUnivEdit,
    CsvDownload,
    CsvUpload
  },
  data () {
    return {
      apiName: "gpath_career_univ_list",
      cvModuleFile: "gpath_career_univ",
      cvModulePrefix: "GCU",
      cvCardTitle: "GPath Career University Configuration",
      cvbtnAddNew: "Add",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit GPathCareerUniv",
      cvAddModalHeader: "Add GPathCareerUniv",
      cvbtnModalCancel: "Cancel",
      cvbtnModalExpand: "Expand",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "GPathCareerUniv List Response",
      showModelGPathCareerUnivAdd: false,
      showModelGPathCareerUnivEdit: false,
      showModelGPathCareerUnivDelete: false,
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "Career", key: "name", class: "text-left align-text-top", sortable: true },
        { label: "country", key: "country", class: "text-left align-text-top", sortable: true },
        { label: "univ name", key: "univ_name", class: "text-left align-text-top", sortable: true },
        { label: "univ url", key: "url", class: "text-left align-text-top", sortable: true }
      ],
      gpath_career_univObjList: null,
      gpath_career_univEditObj: null,
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      delObj: null,
      countryList: [],
      whereFilter: {
        isAdminPanel: true,
        country: "",
        pdt_id: ""
      },
      gpcPdtIdList: []
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()
    this.gpath_career_univList()
    this.gpath_career_univ_countryList()
    this.gpathsproductIdListGet()
  },
  methods: {
    /**
     * Calling SetPdtId into filter
    */
    async setPdtId () {
      this.gpath_career_univList()
    },
    /**
     * set setCountry
     */
    async setCountry () {
      this.gpath_career_univList()
    },
    /**
     * gpath_career_univList
     */
    async gpath_career_univList () {
      try {
        let gpathCareerUnivListResp = await GPathCareerUnivs.gpath_career_univList(this, this.whereFilter)
        if (gpathCareerUnivListResp.resp_status) {
          this.gpath_career_univObjList = gpathCareerUnivListResp.resp_data.data
          this.totalRows = gpathCareerUnivListResp.resp_data.count
        }
        else {
          this.toastMsg = gpathCareerUnivListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.log("Exception occurred at gpath_career_univList() and Exception:", err.message)
      }
    },
    /**
     * gpath_career_univ_countryList
     */
    async gpath_career_univ_countryList () {
      try {
        let gpathCareerCountryListResp = await GPathCareerUnivs.gpath_career_univ_countryList(this)
        if (gpathCareerCountryListResp.resp_status) {
          this.gpath_career_countryObjList = gpathCareerCountryListResp.resp_data.data
          this.countryList = this.gpath_career_countryObjList
        }
        else {
          this.toastMsg = gpathCareerCountryListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.log("Exception occurred at gpath_career_univ_countryList() and Exception:", err.message)
      }
    },
    /**
     * gpath_career_univAdd
     */
    gpath_career_univAdd (type) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/gpath_career_univ_add")
        }
        else {
          this.showModelGPathCareerUnivAdd = true
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_univAdd() and Exception:", err.message)
      }
    },
    /**
     * gpath_career_univEdit
     */
    gpath_career_univEdit (type, item) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/gpath_career_univ_edit/" + this.gpath_career_univEditObj.gcu_id)
        }
        else {
          this.gpath_career_univEditObj = item
          this.showModelGPathCareerUnivEdit = true
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_univEdit() and Exception:", err.message)
      }
    },
    /**
     * showGPathCareerUnivDeleteDialog
     */
    showGPathCareerUnivDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelGPathCareerUnivDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showGPathCareerUnivDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * gpath_career_univDelete
     */
    async gpath_career_univDelete () {
      try {
        let gpathCareerUnivDelResp = await GPathCareerUnivs.gpath_career_univDelete(this, this.delObj.gcu_id)
        await ApiResponse.responseMessageDisplay(this, gpathCareerUnivDelResp)

        if (gpathCareerUnivDelResp && !gpathCareerUnivDelResp) {
          this.showModelGPathCareerUnivDelete = false
          return false
        }

        let index = this.gpath_career_univObjList.indexOf(this.delObj)
        this.gpath_career_univObjList.splice(index, 1)
        this.totalRows = this.totalRows - 1
        this.showModelGPathCareerUnivDelete = false
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_univDelete() and Exception:", err.message)
      }
    },
    /**
     * closeGPathCareerUnivAddModal
     */
    closeGPathCareerUnivAddModal (gpathCareerUnivAddData) {
      try {
        if (gpathCareerUnivAddData) {
          if (this.gpath_career_univObjList && this.gpath_career_univObjList.length >= 1) {
            let gpathCareerUnivObjLength = this.gpath_career_univObjList.length
            let lastId = this.gpath_career_univObjList[gpathCareerUnivObjLength - 1]["id"]
            gpathCareerUnivAddData.id = lastId + 1
          }
          else {
            this.gpath_career_univObjList = []
            gpathCareerUnivAddData.id = 11111
          }

          gpathCareerUnivAddData.created_on = moment()
          this.gpath_career_univObjList.unshift(gpathCareerUnivAddData)
          this.totalRows = this.totalRows + 1
        }

        this.showModelGPathCareerUnivAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closegpath_career_univAddModal() and Exception:", err.message)
      }
    },
    /**
     * closeGPathCareerUnivEditModal
     */
    closeGPathCareerUnivEditModal () {
      try {
        this.showModelGPathCareerUnivEdit = false
      }
      catch (err) {
        console.error("Exception occurred at closeGPathCareerUnivEditModal() and Exception:", err.message)
      }
    },
    /**
     * gpaths product Id List Get
    */
    async gpathsproductIdListGet () {
      try {
        const gpaList = await GPathConfig.gpcList(this, this.whereFilter)
        if (!gpaList.resp_status) {
          ApiResponse.responseMessageDisplay(this, gpaList)
          return
        }
        this.assessmentObjList = gpaList.resp_data.data
        this.gpcPdtIdList = this.assessmentObjList.map(gpc => ({
          id: gpc.gpc_pdt_id
        }))
      }
      catch (err) {
        console.error("Exception in gpathsproductIdListGet() and err: ", err.message)
      }
    }
  }
}
</script>
